import React, { FunctionComponent } from 'react';

type Props = {
  remaining: number;
  id?: string;
  label?: string;
  className?: string;
};

export const Presentation: FunctionComponent<Props> = ({
  id,
  label,
  remaining,
  className,
}) => {
  return (
    <p className={className}>
      残り<span className={label} id={id}>{remaining < 0 ? 0 : remaining}</span>文字
    </p>
  );
};
